import posthog from 'posthog-js';
import { captureException } from '../utils/sentry';
import logger from '@upheal/utils/logger';
import delay from 'delay';

/**
 * Wait for feature flags to load.
 * This can be called multiple times, but it will resolve only once the flags are loaded.
 * If they already are loaded, it will resolve immediately.
 */
export const waitForPostHogFlags = (): Promise<unknown> => {
    return Promise.race([
        new Promise((resolve) => {
            posthog.onFeatureFlags((flags, _, context) => {
                if (context?.errorsLoading) {
                    captureException('[posthog] feature flags failed to load');
                } else {
                    logger.debug('[posthog] feature flags loaded', flags);
                }

                resolve(undefined);
            });
        }),
        // Timeout after 3 seconds to avoid blocking the app in case onFeatureFlags never calls back
        // This should not happen as we set feature_flag_request_timeout_ms to 3 seconds in PostHog config
        delay(3000),
    ]);
};
